import { useNavigate } from "react-router-dom";
import ajaxStations from "../../util/remote/ajaxStations";
import { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import SystemModal from "../Common/SystemModal";
import Loader from "../Common/Loader";
import ajaxStationsGroups from "../../util/remote/ajaxStationsGroups";
const RegisterstationsGroupsModal = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [groupName, setgroupName] = useState("");
  // validation
  const allRowsFilled = () => groupName;
  // submit
  const handleAdd = async (e, closeModal) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }
    const data = {
      group_name: groupName,
    };
    setLoading(true);
    const response = await ajaxStationsGroups.createstationGroups(data);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      resetForm();
      props.func();
      setTimeout(() => {
        closeModal();
      }, 2000);
    } else {
      toast.error(response.message);
    }
  };
  const resetForm = () => {
    setgroupName("");
  };
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={(e) => handleAdd(e, controls.close)}
        disabled={!allRowsFilled() || loading}
      >
        {loading ? "Submiting..." : "Submit"}
      </button>
    </>
  );
  return (
    <SystemModal
      title="Creating Fuel Station Group"
      size="md"
      footer={RenderFooter}
    >
      <Toaster />
      {loading && <Loader />}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Register Fuel Station</h6>
                <form onSubmit={handleAdd}>
                  <div className="row mb-3">
                    {/* Owner */}
                    {/* Station Name */}
                    <div className="col-md-12">
                      <label>
                        Group Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={groupName}
                        onChange={(e) => setgroupName(e.target.value)}
                        className="form-control"
                        placeholder="Enter station name"
                        required
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
export default RegisterstationsGroupsModal;
